import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import React from 'react';
interface BookProps {
  children: React.ReactNode;
  color?: string;
  textColor?: string;
  texture?: boolean;
  depth?: number;
  variant?: 'default' | 'simple';
  illustration?: React.ReactNode;
  width?: number;
  backImage?: string;
}
function Book(props) {
  const $ = _c(30);
  const {
    children,
    color: t0,
    depth,
    texture,
    variant: t1,
    textColor,
    illustration,
    width,
    backImage
  } = props;
  const color = t0 === undefined ? "#f50537" : t0;
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group inline-block w-fit [perspective:900px]");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = (depth || 4) + "cqw";
  const t4 = (width || 196) + "px";
  let t5;
  if ($[1] !== color || $[2] !== t3 || $[3] !== t4 || $[4] !== textColor) {
    t5 = {
      "--book-color": color,
      "--text-color": textColor,
      "--book-depth": t3,
      "--book-width": t4
    };
    $[1] = color;
    $[2] = t3;
    $[3] = t4;
    $[4] = textColor;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[6] !== illustration || $[7] !== variant) {
    t7 = variant !== "simple" && <Stack shrink={true} grow={true} direction="row" className={cn("relative min-w-[calc(var(--book-width))] overflow-hidden bg-[var(--book-color)]")}><div className="bg-book-bind-bg absolute inset-y-0 min-w-[8.2%] opacity-100 mix-blend-overlay" />{illustration && <div className="absolute inset-0">{illustration}</div>}</Stack>;
    $[6] = illustration;
    $[7] = variant;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = variant === "simple";
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-book-bind-bg h-full min-w-[8.2%] opacity-100 mix-blend-overlay" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== children) {
    t10 = <div className="w-full contain-inline-size">{children}</div>;
    $[10] = children;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t8) {
    t11 = <Stack grow={t8} direction="row" className="h-fit">{t9}{t10}</Stack>;
    $[12] = t10;
    $[13] = t8;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== texture) {
    t12 = texture && <div aria-hidden={true} className="bg-ali absolute inset-0 bg-cover bg-no-repeat opacity-60 mix-blend-hard-light" />;
    $[15] = texture;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12 || $[19] !== t7) {
    t13 = <Stack align="stretch" className="border-border shadow-book absolute size-full overflow-hidden rounded-l rounded-r border bg-[var(--book-color)] dark:bg-stone-800">{t7}{t11}{t12}</Stack>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t7;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div aria-hidden={true} className="absolute top-[3px] h-[calc(100%-2*6px)] w-[calc(var(--book-depth)-2px)]" style={{
      backgroundImage: "repeating-linear-gradient(90deg,#ffffff 0 1px,#e5e5e5 1px 3px)",
      transform: "translateX(calc(var(--book-width) - var(--book-depth) / 2 - 3px)) rotateY(90deg) translateX(calc(var(--book-depth) / 2))",
      zIndex: 2
    }} />;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = backImage ? `url(${backImage}) center/cover no-repeat` : "var(--book-color)";
  let t16;
  if ($[22] !== t15) {
    t16 = <div aria-hidden={true} className="book-bg absolute left-0 size-full rounded-l-md rounded-r" style={{
      background: t15,
      transform: "translateZ(calc(-1 * var(--book-depth)))"
    }} />;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t13 || $[25] !== t16) {
    t17 = <div className="relative aspect-[49/60] w-fit min-w-[calc(var(--book-width))] rotate-0 transition-transform duration-500 ease-out contain-inline-size [transform-style:preserve-3d] group-hover:[transform:rotateY(-20deg)_scale(1.066)translateX(-8px)]">{t13}{t14}{t16}</div>;
    $[24] = t13;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17 || $[28] !== t6) {
    t18 = <div className={t2} style={t6}>{t17}</div>;
    $[27] = t17;
    $[28] = t6;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  return t18;
}
import { ComponentProps } from 'react';
type FlexAlignItems = 'stretch' | 'start' | 'end' | 'center';
type FlexJustifyContent = 'stretch' | 'start' | 'end' | 'space-between' | 'space-around' | 'space-evenly' | 'center';
interface StackProps extends ComponentProps<'div'> {
  children: React.ReactNode;
  direction?: 'column' | 'row';
  align?: FlexAlignItems;
  justify?: FlexJustifyContent;
  gap?: number;
  padding?: number;
  grow?: boolean;
  shrink?: boolean;
  wrap?: boolean;
  className?: string;
}
function Stack(props) {
  const $ = _c(26);
  let children;
  let className;
  let etc;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== props) {
    ({
      children,
      shrink: t0,
      grow: t1,
      justify: t2,
      align: t3,
      wrap: t4,
      padding: t5,
      gap: t6,
      direction: t7,
      className,
      ...etc
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = etc;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    children = $[1];
    className = $[2];
    etc = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  const shrink = t0 === undefined ? false : t0;
  const grow = t1 === undefined ? false : t1;
  const justify = t2 === undefined ? "start" : t2;
  const align = t3 === undefined ? "start" : t3;
  const wrap = t4 === undefined ? false : t4;
  const padding = t5 === undefined ? 0 : t5;
  const gap = t6 === undefined ? 0 : t6;
  const direction = t7 === undefined ? "column" : t7;
  const t8 = align === "start" ? "flex-start" : align === "end" ? "flex-end" : align;
  const t9 = justify === "start" ? "flex-start" : justify === "end" ? "flex-end" : justify;
  const t10 = wrap ? "wrap" : "nowrap";
  const t11 = grow ? 1 : 0;
  const t12 = shrink ? 1 : 0;
  const t13 = padding * 4 + "px";
  const t14 = gap * 4 + "px";
  let t15;
  if ($[12] !== direction || $[13] !== t10 || $[14] !== t11 || $[15] !== t12 || $[16] !== t13 || $[17] !== t14 || $[18] !== t8 || $[19] !== t9) {
    t15 = {
      display: "flex",
      flex: "initial",
      flexDirection: direction,
      alignItems: t8,
      justifyContent: t9,
      flexWrap: t10,
      flexGrow: t11,
      flexShrink: t12,
      padding: t13,
      gap: t14
    };
    $[12] = direction;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
    $[18] = t8;
    $[19] = t9;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const stackStyle = t15 as const;
  let t16;
  if ($[21] !== children || $[22] !== className || $[23] !== etc || $[24] !== stackStyle) {
    t16 = <div className={className} style={stackStyle} {...etc}>{children}</div>;
    $[21] = children;
    $[22] = className;
    $[23] = etc;
    $[24] = stackStyle;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}
export { Book };